import { CircleButton, tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

import { CommandButton } from '../PlayerBar.styles'

export const SpeedButton = styled.button`
  background: transparent;
  border: 1px solid ${tokens.colors.black3};
  border-radius: 4px;
  color: ${tokens.colors.black5};
  font-family: Averta;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 8px;
  cursor: pointer;
  min-width: 44px;
  line-height: 1;

  &:hover {
    background: ${tokens.colors.black1};
  }
`

export const Container = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    flex-direction: column;
    justify-content: flex-end;
    flex: 0 0 auto;
    padding: 16px;
    padding-bottom: 32px;
    box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.08);
    background-color: ${tokens.colors.white};
  }
`

export const PlayerButtons = styled.div`
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${tokens.sizes.mdScreen}px) {
    justify-content: space-evenly;
  }
`

export const PlayPauseButton = styled(CircleButton).attrs(props => ({
  iconColor: tokens.colors.white,
  iconSize: 22,
  primary: true,
  bgColor: props.a11yEnabled ? tokens.colors.primary900 : undefined,
  bgColorHover: props.a11yEnabled
    ? tokens.colors.primary800
    : tokens.colors.primary2
}))`
  width: 44px;
  height: 44px;
  margin-left: 14px;
  margin-right: 14px;
`

export const ChaptersButton = styled(CommandButton).attrs(props => ({
  iconName: 'list',
  iconColor: props.disabled ? tokens.colors.black2 : tokens.colors.black5
}))`
  visibility: hidden;

  @media (max-width: ${tokens.sizes.mdScreen}px) {
    visibility: visible;
  }
`

export const PlaybackBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const TimeStamp = styled.span`
  font-family: Averta;
  font-style: normal;
  font-weight: normal;
  font-size: 12.8px;
  line-height: 16px;
  width: 54px;
  text-align: center;
  color: ${tokens.colors.black5};
  padding: 2px;
`

export const LoadingTrack = styled(TimeStamp)`
  opacity: 1;
  animation: fade 2s linear;
  animation-iteration-count: infinite;
  font-size: 18px;

  @keyframes fade {
    0%,
    100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }
`
